import "./Home.scss";

import Intro from "./sections/Intro";
import Map from "./sections/Map";

export default function Home() {
  return (<>
    <Intro />
    <Map />
  </>);
}